import { Routes } from '@angular/router';
import { FeatureFlagEnabledRouteGuard, getFeatureFlagKey } from '@security/authorization/feature-flag-enabled.route-guard';
import { emailPreferencesRoutes } from './email-preferences-api-routes';

/**
 * Modal routes only work at the root level, so these are spread into app-routing alongside the other modal routes.
 */
export const emailPreferencesModalRoutes: Routes = [
  {
    // One segment: LayoutRoutingService passes the whole `(modal:...)` inner string as a single array element.
    path: emailPreferencesRoutes.modalOutletSegment,
    outlet: 'modal',
    canActivate: [FeatureFlagEnabledRouteGuard],
    // allowAnyDomain because this modal opens over both /employee-hub/my-profile (payroll scope) and /my-account
    // (root scope). Unflagged, DomainRouteGuard would resolve an auxiliary route to payroll and redirect an HR-only
    // user away from /my-account.
    data: { ...getFeatureFlagKey(emailPreferencesRoutes.featureFlagKey), allowAnyDomain: true },
    runGuardsAndResolvers: 'always',
    loadComponent: () => import('./modal/email-preferences-modal.component').then((m) => m.EmailPreferencesModalComponent)
  }
];
